const timelinecontrol_store = {
    subscribers:{},
    options:{
        current_active: undefined,
        last_active: undefined,
        speed: 2,
        play: true,
        show_config_form:false,
        opacity: 1,
        fixed:false,
        loop:true
    },
    setOption(option,  value){
        this.options[option] = value
        this.publish('SET_OPTION', {option:option, value:value})
    },
    getOption(option){
        return this.options[option]
    },
    subscribe(topic, callback){
        if(!this.subscribers[topic]){
            this.subscribers[topic] = []
        }
        this.subscribers[topic].push(callback)
    },
    publish(topic, data){
        if(this.subscribers[topic]){
            this.subscribers[topic].forEach(callback => {
                callback(data);
            });
        }
    }
}

export default timelinecontrol_store